import React, { useState } from 'react';
import { Tabs } from 'antd';
import FaoCountryMappingTab from './FaoCountryMappingTab';
import FaoIndicatorMappingTab from './FaoIndicatorMappingTab';
import FaoConvertFetchTab from './FaoConvertFetchTab';

const { TabPane } = Tabs;

const FaoTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const onConvertSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <FaoConvertFetchTab onConvertSuccess={onConvertSuccess} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <FaoIndicatorMappingTab refreshTrigger={refreshKey} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <FaoCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default FaoTabGroup;
